import React from 'react';

interface SectionIconSettingsMoleculeProps {
  configs: {
    showSectionGrid: boolean;
  };
  onConfigChange: (key: string, value: any) => void;
}

export const SectionIconSettingsmolecule: React.FC<SectionIconSettingsMoleculeProps> = ({
  configs,
  onConfigChange,
}) => {
  // eslint-disable-next-line
  if (0) {
    onConfigChange('test', 'test');
    // eslint-disable-next-line
    console.log(configs);
  }
  return (
    <div>
      SectionIconSettingsmolecule
      <div>Under Dev</div>
    </div>
  );
};
